__turbopack_context__.v({
  "ul": "index-module__a0dDEG__ul",
});
